import { type Section } from './types';


const confidentialContent = [
	'rgb(255, 109, 94)',
	'rgb(255,109,94)',
	'#ff6d5e',
];
const internalContent = [
	'rgb(255, 193, 94)',
	'rgb(255,193,94)',
	'#ffc15e',
];

export function cleanConfidential(content: string) {
	let newContent = content;
	[...confidentialContent, ...internalContent].forEach(c =>
		newContent = newContent.replace(c, "transparent"),
	);
	return newContent;
}

export function checkSection(s: Section, allowInternal = false) {
	const conf = confidentialContent.some(c =>s.content.includes(c));
	const int = internalContent.some(c => s.content.includes(c));
	return allowInternal ? !conf : (!conf && !int);
}
